<template>
  <footer class="mainFooter d-none d-md-block">
    <div class="bottomFooter">
      <div class="container">
        <div class="bottomFooterHolder">
          <div class="footer-links">
            <ul>
              <li>
                <router-link to="/">Home</router-link>
              </li>
              <li>
                <router-link to="/about">About Us</router-link>
              </li>
              <li>
                <router-link to="/contact">Contact Us</router-link>
              </li>
              <li>
                <router-link to="/terms">Terms &amp; Conditions</router-link>
              </li>
              <li>
                <router-link to="/accessibility">Accessibility</router-link>
              </li>
              <li>
                <router-link to="/sitemap">Sitemap</router-link>
              </li>
            </ul>
          </div>
        </div>
        <p></p>
        <p>The Health &amp; Safety Group Ltd, Building 5, 3rd Floor, 566 Chiswick High Road,&nbsp;Chiswick, London W4 5YF, Company Reg No 5250327</p>
        <p></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style lang="scss">
.mainFooter {
  width: 100%;
  float: left;
  .bottomFooter {
    width: 100%;
    float: left;
    background: #1b3d82;
    p {
      text-align: center;
      font-size: 13px;
      color: white;
    }
    .bottomFooterHolder {
      border-bottom: 1px solid white;
      width: 100%;
      float: left;
      padding-bottom: 10px;
      margin-bottom: 20px;
      .footer-links {
        text-align: center;
        ul {
          margin-top: 10px;
          padding: 0;
          li {
            display: inline-block;
            padding: 0 35px;
            a {
              font-size: 18px;
              color: white;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .mainFooter .bottomFooter .bottomFooterHolder .footer-links ul li {
    display: block;
  }
}
</style>
